import { defineStore } from 'pinia'

export const useAnalyticStore = defineStore('analytic', () => {
  const all = ref<Analytic[]>([])
  const { $api } = useNuxtApp()

  const fetch = async () => {
    const response = await $api<ApiSuccessResponse<Analytic[]>>('/analytics')
    const data = response.data
    if (data) {
      update(data)
    }
  }

  const update = (payload: Analytic[]) => {
    all.value = payload
  }

  return {
    all,
    fetch,
    update,
  }
})
